import { create } from "zustand";

interface ToastState {
  message: string | null;
  linkLabel: string | null;
  linkHref: string | null;
  show: (message: string, link?: { label: string; href: string }) => void;
  hide: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  message: null,
  linkLabel: null,
  linkHref: null,

  show: (message, link) =>
    set({ message, linkLabel: link?.label ?? null, linkHref: link?.href ?? null }),

  hide: () => set({ message: null, linkLabel: null, linkHref: null }),
}));
